<template>
  <div >
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok"
           :loading="loading" @on-cancel="cancel"
           :width="620"
           :ok-text="'去签约'"
    >
      <div slot="header" class="modal-header">个人预订转签约<span class="dot">.</span><span>{{projectName}}</span></div>

      <div class="row">
        <span class="name">签约房间:</span>
        <div
          :class="['ivu-btn',{'btn-primary2':!this.stockHaveRent}]"
        >{{this.stockNumber}}</div> <span class="haveRent" v-if="this.stockHaveRent">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;该房间已出租</span>
      </div>


      <div class="row " v-if="this.stockHaveRent">
        <span class="name">换签房间:</span>
          <Select
            class="item-width nofundhidden"
            key="room"
            v-if="this.stockHaveRent"
            v-model="formData.changeRoom"
            filterable
            remote
            :transfer="true"
            :remote-method="remoteMethod"
            :loading2="loading2"
            :placeholder="'添加签约房间'">
            <Option v-for="item in roomList" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>

      </div>
      <br>
      <div class="row">
        <span class="name2">- - - - - - - - - - - - - - - - - - - - - - -</span>
      </div>

      <div class="row">
        <span class="name">客户已支付订金：</span>
        <span class="red">{{this.depositAccount}} 元</span>
      </div>
      <div class="row">
        <span class="name">违约金：</span>
        <Input class="width red" v-model="formData.defaultDiscount" @on-blur="calculation"></Input>元
      </div>
      <div class="row">
        <span class="name">订金转合同收款：</span>
        <Input class="width red" v-model="formData.toContractCount" readonly="readonly"></Input>元
      </div>

      <div slot="footer" v-if="this.canRent === 1">
        <span class="red">{{this.tipMsg}}</span>
      </div>
    </Modal>
    <invitation-modal :n="invitationKey"
                      :stockNumber="stockNumber"
                      :cityCode="cityCode"
                      :userPhone="userPhone"
                      :rentType="rentType"
                      :signInviteInfo="signInviteInfo"
                      :isReservation=1
                      @done="close"
    ></invitation-modal>

  </div>


</template>
<script>
  import InvitationModal from '../../../../products/house/cardsView/components/InvitationModal'
  import {reservationToSignInit, updateReservationToSign} from "../../../../../api/book";
  import { getSignInviteInfo } from "api/signInvite";
  import { fuzzyRoom } from 'api/functionalArea';
  export default {
    name: ""   ,
    components:{
      InvitationModal
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
      projectName:{
        type:String,
        default:''
      },
      projectId:{
        type:String,
        default:''
      },
      reservationId:{
        type:String,
        default:''
      }
    },
    watch:{
      n(){
        this.isShow=true
        this.reservationToSignInit()
      }
    },
    data(){
      return {
        formData:{
          "defaultDiscount": 0,
          "defaultParty": 1,
          "reservationOrderFid": 0,
          "toContractCount": 0,
          "changeRoom":''
        },
        formRules: {
          defaultDiscount: [
            {required: true, message: ' ', trigger: 'blur', validator: this.validateNumber2}

          ],
          defaultParty: [
            {required: true, message: ' ', trigger: 'blur', validator: this.validateNumber}
          ],
          toContractCount: [
            {required: true, message: ' ', trigger: 'blur',  validator: this.validateNumber2}
          ],
          changeRoom: [
            {required: true, message: ' ', trigger: 'blur',  validator: this.validateChangeRoom}
          ]
        },
        canRent:0,
        tipMsg:'',
        loading: true,
        loading2:true,
        isShow:false,
        invitationKey:0,
        stockNumber:'',
        changeStockFid:'',
        changeStockNumber:'',
        stockHaveRent:null,
        depositAccount:0,
        stockFid:'',
        cityCode:'',
        userPhone:'',
        rentType:'',
        signInviteInfo:null,
        roomList:[],
      }
    },
    methods:{
      close(){
        console.log('hhhhhhhhh')
        this.isShow=false

      },
      validateNumber2(rule, value, callback) {
        let pattern = /^(\d+)(\.\d+)?$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      validateNumber(rule, value, callback) {
        let pattern = /^\d+$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      validateChangeRoom (rule, value, callback){
        if(this.stockHaveRent === 1 && value===''){
          callback(new Error('请输入房间号'))
        }
        callback();
      },
      calculation(){
        let pattern = /^(\d+)(\.\d+)?$/
        if (!pattern.test(this.formData.defaultDiscount)) {
          this.$Message.error('请输入正确的数字')
          this.formData.defaultDiscount = 0
        }
        this.formData.defaultDiscount = parseInt(this.formData.defaultDiscount)
        if(this.formData.defaultDiscount < 0){
          this.$Message.error('违约金额不能小于0')
          this.formData.defaultDiscount = 0
        }
        if(this.formData.defaultDiscount > this.depositAccount){
          this.$Message.error('违约金不能大于已支付定金')
          this.formData.defaultDiscount = this.depositAccount
        }
        this.formData.toContractCount = parseInt(this.depositAccount - this.formData.defaultDiscount)
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },

      reservationToSignInit() {
        let param = {
          reservationId: this.reservationId
        }
        reservationToSignInit(param).then(res=>{
            this.stockFid = res.data.stockFid
            this.stockNumber = res.data.roomNum
            this.stockHaveRent = res.data.stockHaveRent === 0 ? null : true
            this.depositAccount = res.data.depositAccount
            this.cityCode = res.data.cityCode
            this.userPhone = res.data.userPhone
            this.rentType = res.data.rentType + ""
            this.formData.defaultDiscount = 0
            this.formData.toContractCount = res.data.depositAccount
            this.formData.changeRoom = ''
            this.canRent = res.data.canRent
            this.tipMsg = res.data.tipMsg

        }).catch(error=>{
          this.changeLoading()
        })
      },
      remoteMethod(query){
        if (query !== '' && this.projectId !=='') {
          this.loading2 = true;
          let params = {
            projectid:this.projectId,
            roomnumber:query,
            roomStatus: 0,
            stockIsOrder: 2
          }
          fuzzyRoom(params).then( res => {
            this.loading2 = false;

            this.roomList = res.data;
          })
        } else {
          this.roomList = [];
          this.formData.changeRoom=''
        }
      },
      ok() {
        if(this.stockHaveRent){
          if(this.formData.changeRoom === ''){
            this.$Message.error('请添写换租房间')
            return;
          }
          let obj = {};
          obj = this.roomList.find((item)=>{
            return item.value === this.formData.changeRoom;
          });
          this.changeStockFid = obj.value;
          this.changeStockNumber= obj.text;
        }
        let param = {
          "fid": this.reservationId,
          "stockFid": this.stockFid,
          "roomNum": this.stockNumber,
          "stockHaveRent": this.stockHaveRent?1:0,
          "toContractCount": this.formData.toContractCount,
          "defaultAccount": this.formData.defaultDiscount,
          "changeStockFid":this.changeStockFid,
          "changeRoomNum":this.changeStockNumber
        }
        updateReservationToSign(param).then(res => {
          // 签约邀请接口
          var stockFidToSign = this.stockFid;
          if(this.stockHaveRent){
            stockFidToSign = this.changeStockFid
            this.stockNumber = this.changeStockNumber.split("-")[2]
          }
          getSignInviteInfo(stockFidToSign).then(res => {
            this.signInviteInfo = res.data
            this.invitationKey++
            // this.isShow = false
            this.changeLoading()
          }).catch(error => {
            this.changeLoading()
          })
        }).catch(error => {
          this.changeLoading()
        })
      },
      cancel(){

      }
    }

  }
</script>

<style scoped>

  .row{
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  .name{
    width:100px;

  }
  .name2{
    /*width:200px;*/
    color:grey;

  }
  .width{
    width: 150px;

  }
  .red{
    color: red;
    -webkit-text-fill-color: red;
  }
  .item-width{
    width: 260px;
  }
  .haveRent{
    color:grey;
  }


</style>
